import type {
    BootstrapCommerceSessionRequest,
    BootstrapCommerceSessionResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";

/** Stable transport operation used to establish the Commerce session. */
export const bootstrapCommerceSessionOperation = defineCommerceOperation<
    BootstrapCommerceSessionRequest,
    BootstrapCommerceSessionResponse
>("commerce.session.bootstrap");
